export const forumCategories = [
  { value: 'help', label: 'Help' },
  { value: 'bugs', label: 'Bugs' },
  { value: 'channels', label: 'Channels' },
  { value: 'repeaters', label: 'Repeaters' },
  { value: 'firmware', label: 'Firmware' },
  { value: 'feature-request', label: 'Feature request' },
  { value: 'show-and-tell', label: 'Show and tell' },
  { value: 'announcement', label: 'Announcement' },
] as const

export const forumTags = [
  'GMRS',
  'Amateur',
  'Baofeng',
  'UV-5R',
  'Repeater',
  'Programming',
  'Antenna',
  'Mobile',
  'Firmware',
  'CHIRP',
  'Mac',
  'Windows',
  'Linux',
] as const

export const forumBadges = [
  {
    value: 'contributor',
    label: 'Contributor',
    description: 'Awarded when one of your replies is marked as a solution.',
  },
  {
    value: 'forum-regular',
    label: 'Forum Regular',
    description: 'Awarded automatically after 10 forum topics and replies.',
  },
  {
    value: 'forum-veteran',
    label: 'Forum Veteran',
    description: 'Awarded automatically after 50 forum topics and replies.',
  },
  {
    value: 'radio-tester',
    label: 'Radio tester',
    description: 'Assigned manually for verified radio testing.',
  },
  {
    value: 'driver-tester',
    label: 'Driver tester',
    description: 'Assigned manually for driver testing and feedback.',
  },
  {
    value: 'beta-tester',
    label: 'Beta tester',
    description: 'Assigned manually for beta-program participation.',
  },
] as const

export function categoryLabel(value: string) {
  return forumCategories.find((category) => category.value === value)?.label || value
}

export function badgeLabel(value: string) {
  return forumBadges.find((badge) => badge.value === value)?.label || value
}

export function badgeDescription(value: string) {
  return forumBadges.find((badge) => badge.value === value)?.description || ''
}
